import { handleError } from 'helper/rest'
import { clientPublic, clientPublicService } from 'helper/axios'

export const getTaskAll = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(
        `sprintflow/task`,
        params,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const chooseTask = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`sprintflow/choose`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
export const getSubTaskById = async ({ params, token }) => {
  try {
    return await clientPublic
      .get(`sprintflow/${params.id}?project_id=${params.project_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getListSubtask = async ({ params, token }) => {
  try {
    return await clientPublic
      .get(`sprintflow?project_id=${params.id}&level=2&level_id=${params.subtask_id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const getEventlogList = async ({ params, token }) => {
  try {
    return await clientPublic
      .get(
        `eventlog?project_id=${params.project_id}&sprintflow_id=${params.sprintflow_id}&orderby=id|desc&limit=100`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const onSendback = async ({ params, token }) => {
  try {
    return await clientPublic
      .post(`sprintflow/sendback`, params, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}

export const updateKeyActionStatus = async ({ data, token }) => {
  try {
    return await clientPublicService
      .post(`core/key-action/update-status`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if (response.status === 400) {
          return response
        }
        return handleError(response)
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
//HISTORY INBOX API
export const getHistoryInbox = async ({ token, params }) => {
  try {
    return await clientPublic
      .post(
        `sprintflow/task/complete`,
        params,

        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        return response
      })
      .catch((error) => {
        const { response } = error
        if ([401, 403].includes(response.status)) {
          return handleError(response)
        }
        return response
      })
  } catch (error) {
    console.error('error', error)
    return error
  }
}
